/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, Vue } from "vue-property-decorator"
import { getRolesList, getRoleAuthority, setRoleFunctions, setRoleName, delRole, getLevel5RoleFunctionsById } from '@/api/authority'

@Component({})
export default class AuthoritySetting extends Vue {
    // ------ 变量 ------
    functionsList: any = [] // 权限列表
    functionsList3: any = [] // 数据列表
    editBtn = true
    confirmBtn = false // 确认按钮是否出现
    roleList: any = [] // 角色 列表
    roleId = 0 // 当前操作的角色ID
    addRoleShow = false // 新建角色的弹框
    newRoleName = '' // 新建角色的名字
    editRoleShow = false // 修改角色的弹框
    editRoleName = '' // 修改角色的名字
    delRoleShow = false // 删除角色弹框
    checkAuthority1: Array<number> = [] // 选中的权限列表
    checkAuthority2: Array<number> = []
    checkAuthority3: Array<number> = []
    checkAuthority: Array<number> = []
    loading = false
    disFoldBtn = false
    // 订单查看权限
    level5RoleOption: any = [] //查看权限数组
    level5OrderOption: any = [] //查看订单权限数组
    level5cooperateOption: any = [] //查看合作管理权限数组
    level5Option: any = [] //查看总项目权限数组
    checkAll = false
    checkedCities = []
    flodBtn = true //展开收起
    levelOptions: any = []
    parentLevelOptions: any = []
    drawerShow = false // 右侧抽屉
    checkId = null // 查看权限ID
    role_id = null // 查看权限ID
    drawerItem: any = {}
    editRoleLoading =  false
    addRoleLoading =  false
    // ------ 生命周期 ------
    created() {
        this.initRoleList()
    }

    // ------ 方法 ------
    handleCheckAllChange(child) {
        // 选中之后子级全部选中,取消后子级全部取消选中
        if(child.flag) {
            const arr = child.functions
            for(let i = 0; i < arr.length; i++ ){
                arr[i].flag = true
                this.checkAuthority.push(arr[i].id) //二级菜单
            }
            const bol = arr.some(item => item.flag)
            if(bol){
                child.flag = true
                this.checkAuthority.push(child.id) //1级菜单
            }
        } else {
            this.checkAuthority.splice(this.checkAuthority.indexOf(child.id),1)
            const arr = child.functions
            for(let i = 0; i < arr.length; i++ ){
                arr[i].flag = false
                this.checkAuthority = this.checkAuthority.reduce((acc, curr) => {
                    if (!acc.includes(curr)) {
                        acc.push(curr);
                    }
                    return acc;
                }, []);
                if(this.checkAuthority.indexOf(arr[i].id) != -1){
                    this.checkAuthority.splice(this.checkAuthority.indexOf(arr[i].id),1)
                }
            }
        }
        // this.parentLevelOptions = []
        // this.level5RoleOption.map(items => {
        //     if(items.flag && (items.id == id)){
        //         const arr = items.functions
        //         for(let i = 0; i < arr.length; i++ ){
        //             arr[i].flag = true
        //             this.checkAuthority.push(arr[i].id)
        //         }
        //         this.parentLevelOptions.push(items.id)

        //     }else if(!items.flag && (items.id == id)){
        //         const arr = items.functions
        //         for(let i = 0; i < arr.length; i++ ){
        //             arr[i].flag = false
        //             this.checkAuthority.splice(this.checkAuthority.indexOf(arr[i].id),1)
        //         }
        //     }
        // })
    }
    handleCheckedCitiesChange(item,childItem) { //item-项目类型,childItem子类型
        const arr = item.functions //子级只要有一项为true父级就为true
        if(childItem.flag){
            const bol = arr.some(item => item.flag)
            if(bol){
                item.flag = true
                this.checkAuthority.push(item.id) //1级菜单
            }
            for(let i = 0; i < arr.length; i++ ){
                if(arr[i].id == childItem.id){
                    this.checkAuthority.push(childItem.id) //2级菜单
                }
            }
        }else {
            for(let i = 0; i < arr.length; i++ ){
                if(arr[i].id == childItem.id){
                    if(this.checkAuthority.indexOf(arr[i].id) != -1){
                        this.checkAuthority.splice(this.checkAuthority.indexOf(arr[i].id),1)
                    }
                }
            }
        //     如果所有子级都未被选中，则取消父级勾选
           if(!arr.some(item => item.flag)){
               item.flag = false
           }
        }
    }
    // -----以前----
    async initRoleList() {  //获取左侧角色列表
        const data: any = await getRolesList()
        this.roleList = data
        this.roleId = this.roleList[0].id
        this.getRoleAuthority(this.roleId)
    }
    async getRoleAuthority(id: number) {  //点击左侧菜单
        this.loading = true
        this.roleId = id
        const data: any = await getRoleAuthority({ id })
        this.functionsList = []  //功能权限
        this.functionsList3 = [] //数据权限
        data.functionsList.forEach((item: any) => {
            if(item.level === 3) {
                this.functionsList3.push(item)  //数据权限
            } else {
                this.functionsList.push(item)  //功能权限
            }
        });
        this.role_id = id
        // this.getLevel5Role()
        this.checkAuthority = data.functionsIdList  //选中id
        this.confirmBtn = false
        this.editBtn = true
        this.loading = false
        this.flodBtn = true
        let element = document.querySelector('#parent') || window;
        element.scrollTo(0, 0);
    }

    async addRole() {
        if (this.newRoleName === '') {
            this.$message.error('角色名字不能为空')
            return
        }
        this.addRoleLoading = true
        await setRoleName({name: this.newRoleName}).then(() => {
            this.$message.success('新建角色成功')
            this.newRoleName = ''
            this.initRoleList()
            this.addRoleLoading = false
            this.addRoleShow = false
        }).catch(err => {
            this.addRoleLoading = false
        })
    }

    async editRole() {
        if (this.editRoleName === '') {
            this.$message.error('角色名字不能为空')
            return
        }
        this.editRoleLoading = true
        await setRoleName({name: this.editRoleName, id: this.roleId}).then(() => {
            this.$message.success('修改角色名称成功')
            this.initRoleList()
            this.editRoleShow = false
            this.editRoleLoading = false
        }).catch(() => {
            this.editRoleLoading = false
        })
    }
    clickEditIcon(name: string) {
        this.editRoleName = name
        this.editRoleShow = true
    }
    async DelRole() {
        this.delRoleShow = false
        await delRole({ id: this.roleId })
        this.$message.success('删除角色成功')
        this.initRoleList()
    }
    checkAuthorityChanges(obj: any,childItem){
        const arr = obj.functions //子级只要有一项为true父级就为true
        if(childItem.flag){
            const bol = arr.some(item => item.flag)
            if(bol){
                obj.flag = true
                this.checkAuthority.push(obj.id) //1级菜单
            }
            for(let i = 0; i < arr.length; i++ ){
                if((arr[i].id == childItem.id)){
                    this.checkAuthority.push(arr[i].id) //2级菜单
                }
            }
        }else {
            for(let i = 0; i < arr.length; i++ ){
                if((arr[i].id == childItem.id)){
                    if(this.checkAuthority.indexOf(arr[i].id) != -1){
                        this.checkAuthority.splice(this.checkAuthority.indexOf(arr[i].id),1)
                    }
                }
            }
        }
    }
    //功能权限大标题
    checkAuthorityChange(obj: any) {
        switch(obj.level) {
            case 1:
                if(obj.flag) {
                    this.checkAuthority.push(obj.id)
                    const arr = obj.functions
                    for(let i = 0; i < arr.length; i++ ){
                        arr[i].flag = true
                        this.checkAuthority.push(arr[i].id) //二级菜单
                    }
                } else {
                    this.checkAuthority.splice(this.checkAuthority.indexOf(obj.id),1) //父级
                    // let levalArr = []
                    // if(obj.id == 8 && this.level5OrderOption.length > 0){
                    //     levalArr = this.level5OrderOption
                    // }
                    // levalArr.map(item => {
                    //     item.flag = false
                    //     this.checkAuthority.splice(this.checkAuthority.indexOf(item.id),1)
                    //     item.functions.map(items => {
                    //         items.flag = false
                    //         this.checkAuthority.splice(this.checkAuthority.indexOf(items.id),1)
                    //     })
                    // })
                    // this.level5OrderOption = levalArr  //项目类型
                    const arr = obj.functions
                    for(let i = 0; i < arr.length; i++ ){
                        arr[i].flag = false
                        if(this.checkAuthority.indexOf(arr[i].id) != -1){
                            this.checkAuthority.splice(this.checkAuthority.indexOf(arr[i].id),1)
                        }
                    }
                }
                break
            case 2:
                // if(obj.flag) {
                //     // 子级有一项选中父级就选中
                //     this.checkAuthority2.push(obj.id)
                // } else {
                //     this.checkAuthority2.splice(this.checkAuthority2.indexOf(obj.id),1)
                //     this.checkAuthority.splice(this.checkAuthority.indexOf(obj.id),1)
                // }
                break
            case 3:
                if(obj.flag) {
                    this.checkAuthority3.push(obj.id)
                } else {
                    this.checkAuthority3.splice(this.checkAuthority3.indexOf(obj.id),1)
                    this.checkAuthority.splice(this.checkAuthority.indexOf(obj.id),1)
                }
        }
        this.checkAuthority = [...this.checkAuthority2, ...this.checkAuthority1, ...this.checkAuthority3, ...this.checkAuthority]
        this.checkAuthority = Array.from(new Set(this.checkAuthority))
    }
    async preservation() {
        let arr = []
        let arr1 = []
        // this.level5Option.map(item => {
        //     if(item.flag){
        //         arr.push(item.id)
        //     }
        //     item.functions.map(items => {
        //         if(items.flag){
        //             arr1.push(items.id)
        //         }
        //     })
        // })
        // this.level5OrderOption.map(item => {
        //     if(item.flag){
        //         arr.push(item.id)
        //     }
        //     item.functions.map(items => {
        //         if(items.flag){
        //             arr1.push(items.id)
        //         }
        //     })
        // })
        this.checkAuthority = [...arr,...arr1, ...this.checkAuthority,...this.checkAuthority1,...this.checkAuthority2,  ...this.checkAuthority3]
        // this.checkAuthority = [...this.levelOptions, ...this.checkAuthority,...this.parentLevelOptions]
        this.checkAuthority = Array.from(new Set(this.checkAuthority))
        await setRoleFunctions({ roleId: this.roleId, functionsIds: this.checkAuthority })
        this.checkAuthority = []
        this.checkAuthority1 = []
        this.checkAuthority2 = []
        this.checkAuthority3 = []
        this.levelOptions = []
        this.$message.success('角色权限修改成功')
        this.getRoleAuthority(this.roleId)
        this.confirmBtn = false
        this.editBtn = true
    }
    handleClickScope(item){
        this.drawerShow = true
        this.checkId = item.id
        this.drawerItem = item
        this.getLevel5Role()

    }
    async getLevel5Role() {
        const data: any = await getLevel5RoleFunctionsById({roleId: this.role_id, id: this.checkId})
        this.level5RoleOption = data.level5FunctionsList

        // 如果已经打开了 ，则勾选上次已经选择的项目 ，取消已经选择的项
        this.level5RoleOption.forEach(item => {
            item.functions.forEach(items => {
                //  取消没有的
                if(this.checkAuthority.indexOf(items.id)==-1){
                    items.flag = false
                }
                // 如果所有子级都被取消了,那么父级也取消
                if( !item.functions.some(item => item.flag)){
                    item.flag = false
                }
                this.checkAuthority.forEach(item1s => {
                    if (items.id == item1s) {
                        items.flag = true
                        //     只要有选中的，那么父级也勾选
                        item.flag = true
                    }
                })
            })
        })
    }
    drawerClose(done: any) {
        this.level5RoleOption =  []
        done()
    }
    disabledCheckRight(item: any){
        if(this.confirmBtn){  //编辑
            return item.flag
        }else {
            return false
        }
    }
    disabledCheck1(item: any) {
        if(this.confirmBtn){
            return true
        }else{
            return false
        }
    }
    disabledCheck2(flag: any) {
        if (this.confirmBtn) {
            return true
        } else {
            return false
        }
    }
    disabledCheck3(item,flag) {  //项目类型
        if (this.confirmBtn) {
            return true
        } else {
            return false
        }
    }

    disabledCheck4(item) {
        if (this.confirmBtn) {
            let arr = []
            if(item.flag && item.name == '订单'){
                this.level5RoleOption.map(item => {
                    arr.push(item.flag)
                })
                let bol = arr.every((item) => {
                    return !item
                }) //bol为true说明一个选中的都没有
                if(bol){
                    return true
                }else {
                    return false
                }
            }
        } else {
            return false
        }
    }
    disabledCheck5(flag: any){
        if (this.confirmBtn) {
            return true
        } else {
            return false
        }
    }
    clickEditor() {
        this.confirmBtn = true
        this.editBtn = false
    }

    // ------ 监听 ------

}
